export default __webpack_public_path__ + "static/media/cloud-upload.47f780d0.svg";